export default "__VITE_ASSET__CFSWmDCf__"